import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const appleBusinessManager = defineConnector({
  identifier: "appleBusinessManager",
  name: "Apple Business Manager",
  tagLine: "Device and content management for organizations",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api-business\\.apple\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an API account in Apple Business Manager",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Apple Business Manager](https://business.apple.com), go to **Settings › API**, and create an API account. Download the private key and note your client ID and key ID.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          helperText: "The client ID generated when you create an API account.",
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Key ID",
          required: true,
          helperText: "The key ID generated when you create an API account.",
          target: { kind: "configuration", field: "keyId" },
        },
        {
          kind: "file",
          label: "Private key (.pem)",
          accept: ".pem",
          helperText:
            "The .pem file downloaded when you created the API account, used to sign the client assertion JWT.",
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    clientCredentialsFrom: "db",
    tokenEndpoint: () => "https://account.apple.com/auth/oauth2/token",
    tokenEndpointAuthMethod: () => "private_key_jwt",
    // Apple documents the assertion audience as the `/v2/` path even though the
    // token request itself goes to the path without it.
    clientAssertion: ({ keyId }) => ({
      keyId,
      audience: "https://account.apple.com/auth/oauth2/v2/token",
    }),
    scopes: () => ["business.api"],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api-business.apple.com/v1/orgDevices?limit=1",
  },
});
